export const transformString = (inputString: string) => {
    return inputString
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
};
